import { __awaiter } from "tslib";
import { callWithRetry } from './callWithRetry';
export const waitForChatSdkReady = () => __awaiter(void 0, void 0, void 0, function* () {
    const checkSdkReady = () => __awaiter(void 0, void 0, void 0, function* () {
        if (window.__CHAT_SDK) {
            return true;
        }
        else {
            throw new Error('Chat SDK not ready');
        }
    });
    try {
        yield callWithRetry(checkSdkReady, 8);
    }
    catch (e) {
        console.error('RE:SDK: Chat SDK not ready after 8 tries');
        throw e;
    }
});
